export default __webpack_public_path__ + "static/media/Winter_15.7b940f67.png";